/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GroupEventModel
 */
export interface GroupEventModel {
    /**
     * 
     * @type {string}
     * @memberof GroupEventModel
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupEventModel
     */
    createdBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GroupEventModel
     */
    createdDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GroupEventModel
     */
    timePeriodDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GroupEventModel
     */
    policyNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupEventModel
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupEventModel
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupEventModel
     */
    jsonData?: string | null;
}

/**
 * Check if a given object implements the GroupEventModel interface.
 */
export function instanceOfGroupEventModel(value: object): value is GroupEventModel {
    return true;
}

export function GroupEventModelFromJSON(json: any): GroupEventModel {
    return GroupEventModelFromJSONTyped(json, false);
}

export function GroupEventModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupEventModel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'timePeriodDate': json['timePeriodDate'] == null ? undefined : (new Date(json['timePeriodDate'])),
        'policyNumber': json['policyNumber'] == null ? undefined : json['policyNumber'],
        'status': json['status'] == null ? undefined : json['status'],
        'type': json['type'] == null ? undefined : json['type'],
        'jsonData': json['jsonData'] == null ? undefined : json['jsonData'],
    };
}

export function GroupEventModelToJSON(json: any): GroupEventModel {
    return GroupEventModelToJSONTyped(json, false);
}

export function GroupEventModelToJSONTyped(value?: GroupEventModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'timePeriodDate': value['timePeriodDate'] == null ? undefined : ((value['timePeriodDate']).toISOString()),
        'policyNumber': value['policyNumber'],
        'status': value['status'],
        'type': value['type'],
        'jsonData': value['jsonData'],
    };
}

